import { LoadingButton } from '@mui/lab';
import {
  Avatar,
  Box,
  Button,
  CardContent,
  Grid,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { api } from 'src/Api';
import Alert from '@mui/material/Alert';

export default function ProtectionFeeModal({ handleClose, protection, refreshAdmin }) {
  const [alert, setalert] = useState({ visible: false, message: '' });

  const [minprice, setMinPrice] = useState('');
  const [maxprice, setMaxPrice] = useState('');
  const [fixedprice, setFixedPrice] = useState('');
  const [percentage, setPercentage] = useState('');
  const [loading, setloading] = useState('');
  function AddProtectionFee() {
    setloading(true);
    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();

    formdata.append('min_price', minprice);
    formdata.append('max_price', maxprice);
    formdata.append('percentage', percentage);
    formdata.append('fixed_amount', fixedprice);
    protection && formdata.append('id', protection?.id);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    setloading(true);
    fetch(protection ? api.edit_buyer_protection_fee : api.add_buyer_protection_fee, requestOptions)
      // fetch(api.add_buyer_protection_fee, requestOptions)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          return response.text();
        } else {
          return response.json().then((result) => {
            setalert({ visible: true, message: result.error });
          });
        }
      })
      .then((result) => {
        const response = JSON.parse(result);
        refreshAdmin();
      })
      .catch((error) => {
        console.log('error', error);
      })
      .finally(() => setloading(false));
  }

  const handleMaxProductChange = (e) => {
    // const newMaxProduct = parseFloat(event.target.value);

    // if (!isNaN(newMaxProduct)) {
    //   setMaxPrice(newMaxProduct + 1);
    // } else {
    //   console.warn('Invalid input: Please enter a number for maximum product.');
    // }

    const value = e.target.value;
    if (value == '') {
      setMaxPrice(value);
    }
    if (/^\d*$/.test(value) && parseInt(value) <= 100000) {
      // Ensure only numbers and max value is 100
      setMaxPrice(value);
    }
  };

  useEffect(() => {
    if (protection) {
      setMinPrice(protection?.min_price);
      setMaxPrice(protection?.max_price);
      setFixedPrice(protection?.fixed_amount);
      setPercentage(protection?.percentage);
    }
  }, []);

  return (
    <Box p={1} mt={2} style={{ width: '100%' }}>
      <Typography variant="h4" style={{ fontWeight: 'bold', textAlign: 'center' }}>
        {t(protection ? 'Edit Buyer Protection fee' : 'Add Buyer Protection fee')}
      </Typography>
      <CardContent>
        <Grid container spacing={2} className="top_column">
          <>
            <Grid item lg={6} sm={12} md={12}>
              <TextField
                id="outlined-error-helper-text"
                fullWidth
                label={'Min Price (LKR)'}
                type="number"
                value={minprice}
                onChange={(e) => {
                  // setMinPrice(val.target.value);
                  const value = e.target.value;
                  if (value == '') {
                    setMinPrice(value);
                  }
                  if (/^\d*$/.test(value) && parseInt(value) <= 100000) {
                    // Ensure only numbers and max value is 100
                    setMinPrice(value);
                  }
                }}
                variant="outlined"
                display="inline"
              />
            </Grid>
            <Grid item lg={6} sm={12} md={12}>
              <TextField
                id="outlined-error-helper-text"
                fullWidth
                label={'Max Price (LKR)'}
                type="number"
                value={maxprice}
                onChange={handleMaxProductChange}
                variant="outlined"
                display="inline"
              />
            </Grid>

            <Grid item lg={6} sm={12} md={12}>
              <TextField
                id="outlined-error-helper-text"
                fullWidth
                label={'Fix Price (LKR)'}
                // type="text"
                type="number"
                value={fixedprice}
                onChange={(e) => {
                  // setFixedPrice(val.target.value);
                  const value = e.target.value;
                  if (value == '') {
                    setFixedPrice(value);
                  }
                  if (/^\d*$/.test(value) && parseInt(value) <= 100000) {
                    // Ensure only numbers and max value is 100
                    setFixedPrice(value);
                  }
                }}
                variant="outlined"
                display="inline"
              />
            </Grid>
            <Grid item lg={6} sm={12} md={12}>
              <TextField
                id="outlined-error-helper-text"
                fullWidth
                label="Percentage (%)"
                type="text"
                value={percentage}
                onChange={(val) => {
                  const value = val.target.value;

                  const sanitizedValue = value.replace(/[^0-9]/g, '');

                  if (sanitizedValue === '' || (sanitizedValue >= 0 && sanitizedValue <= 100)) {
                    setPercentage(sanitizedValue);
                  }
                }}
                variant="outlined"
              />
            </Grid>
          </>
        </Grid>
        <Box mt={2}></Box>
        {alert && alert.visible && <Alert severity="error">{alert.message}</Alert>}
      </CardContent>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          p: 2
        }}
      >
        <LoadingButton
          loading={loading}
          sx={{
            marginRight: 1
          }}
          onClick={() => {
            if (parseInt(maxprice) < parseInt(minprice)) {
              setalert({
                visible: true,
                message:
                  'The value in the Min Price field cannot be greater than the value in the Max Price field'
              });
            } else {
              AddProtectionFee();
            }
          }}
          color="primary"
          variant="contained"
        >
          {/* {t('EditProfile.buttons.1')} */}
          Save
        </LoadingButton>
        <LoadingButton
          sx={{
            marginRight: 1
          }}
          onClick={handleClose}
          variant="outlined"
        >
          {/* {t('EditProfile.buttons.2')}
           */}
          Cancel
        </LoadingButton>
      </Box>
    </Box>
  );
}
